if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      imgsrcs=[];
      imgsrcsDict = {};

      constructor() {
        super();
        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
        const variant = this.getSelectedVariant(this);
        if (this.dataset.layout == "card")
          this.updateCardMedia(variant?.featured_media?.id);
        if (this.dataset.zoomClick == 'lightbox') this.initPhotoSwipe();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initPhotoSwipe(){
        this.imgsrcs = [];
        this.querySelectorAll("li[data-media-id]").forEach((element, index) => {
          element.addEventListener("click", this.openPhotoSwipe.bind(this));
          element.idx = index;
          var imgElement = element.getElementsByTagName("img")[0];
          this.imgsrcs.push({
            src: imgElement.src,
            w: imgElement.getAttribute("data-width"),
            h: imgElement.getAttribute("data-height"),
          });
        });
      }

      openPhotoSwipe(e){
        var pswpElement = this.querySelectorAll(".pswp")[0];
        var options = {
          index: e.currentTarget.idx,
          history: false,
          focus: false,
          tapAction: "close",
          bgOpacity: 0.6,
        };
        var gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          this.imgsrcs,
          options
        );
        gallery.init();
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" &&
          shouldSwapProduct &&
          this.dataset.layout != "card";

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback:
            shouldSwapProduct && this.dataset.layout != "card"
              ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
              : this.handleUpdateProductInfo(productUrl, shouldFetchFullPage),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            if (this.dataset.layout == "card") {
              var wc_forloop_index = parseInt(
                document
                  .querySelector(`#${targetId}`)
                  .getAttribute("data-forloop-index")
              );
              const originalHtml = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const html = originalHtml.getElementById(this.id)
                ? originalHtml.getElementById(this.id)
                : originalHtml;
              if (wc_forloop_index >= 0) {
                html
                  .querySelectorAll(".wc_selector_operation")
                  .forEach(function (self, index) {
                    self.setAttribute("data-forloop-index", wc_forloop_index);
                    var wc_name_attr = self.getAttribute("name");
                    self.setAttribute("name", wc_name_attr + wc_forloop_index);
                  });
              }
              callback(html);
            } else {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              if (html.tagNam == "PRODUCT-INFO")
                html.setAttribute("data-update-url", "false");
              else if (
                html.querySelector("product-info") &&
                this.dataset.isQuickView
              ) {
                html
                  .querySelector("product-info")
                  .setAttribute("data-update-url", "false");
                html
                  .querySelector("product-info")
                  .setAttribute("data-is-quick-view", "true");
              }
              callback(html);
            }
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant =
          productInfoNode.querySelector(
            "variant-selects [data-selected-variant]"
          )?.innerHTML ||
          productInfoNode.querySelector("color-swatch [data-selected-variant]")
            ?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];
        !shouldFetchFullPage &&
          params.push(`section_id=${this.dataset.originalSection}`); //params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }
        return `${url}${url.indexOf("?") >= 0 ? "&" : "?"}${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }
      updateCardVendor(vendorName) {
        const card = this.closest(".card") || this.querySelector(".card");
        if (!card) return;

        const vendorElement = card.querySelector(".card_vendor");
        if (vendorElement) {
          vendorElement.textContent = vendorName;
        }
      }
      updateCardProductType(productType) {
        const productTypeElement = this.querySelector(".card_type");
        if (productTypeElement) {
          productTypeElement.textContent = productType;
        }
      }
      updateCardTitle(productTitle) {
        const productTitleElement = this.querySelector(".full-unstyled-link");
        if (productTitleElement) {
          productTitleElement.textContent = productTitle;
        }
      }
      handleUpdateProductInfo(productUrl, updateFullPage) {
        return (html) => {
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          const vendorName = html.querySelector(".card_vendor")?.textContent;

          if (vendorName) {
            this.updateCardVendor(vendorName);
          } else {
            this.updateCardVendor("");
          }

          const productType = html.querySelector(".card_type")?.textContent;
          if (productType) {
            this.updateCardProductType(productType);
          } else {
            this.updateCardProductType("");
          }

          const productTitle = html.querySelector(
            ".full-unstyled-link"
          )?.textContent;
          if (productTitle) {
            this.updateCardTitle(productTitle);
          }

          if (this.dataset.layout == "card") {
            if (this.dataset.url != productUrl) {
              const productMediaItem = html.querySelectorAll(
                ".product__media-item"
              );
              productMediaItem.forEach((mediaItem) => {
                mediaItem.dataset.mediaId = this.replaceStringBeforeLastDash(
                  mediaItem.dataset.mediaId,
                  `${this.dataset.section}-${this.dataset.productId}`
                );
              });
              this.querySelector(".card__media").innerHTML =
                html.querySelector(".card__media").innerHTML;
            }
            this.dataset.url = productUrl;
          }

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }
          if (variant.id && this.dataset.isQuickView) {
            this.querySelector(
              'input.product-variant-id[name="id"]'
            ).setAttribute("value", variant.id);
          }

          this.updateMedia(html, variant?.featured_media?.id);
          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.querySelector(`#${id}-${this.sectionId}`);
            var main_url_1 = `#${id}-${this.dataset.section}`;
            var main_url_2 = `#${id}-quickadd-${this.dataset.section}`;
            const destination = this.querySelector(main_url_1)
              ? this.querySelector(main_url_1)
              : this.querySelector(main_url_2);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination(
            "badge",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

	          this.updateQuantityRules(this.sectionId, html);
	          this.updateBuyButtonsFromHtml(html);
	          this.syncSubmitButtonDataFromHtml(html);

	          if (this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) {
            this.querySelector(
              `#Quantity-Rules-${this.dataset.section}`
            )?.classList.remove("hidden");
          } else {
            this.querySelector(
              `#Quantity-Rules-quickadd-${this.dataset.section}`
            )?.classList.remove("hidden");
          }
          if (this.querySelector(`#Volume-Note-${this.dataset.section}`)) {
            this.querySelector(
              `#Volume-Note-${this.dataset.section}`
            )?.classList.remove("hidden");
          } else {
            this.querySelector(
              `#Volume-Note-quickadd-${this.dataset.section}`
            )?.classList.remove("hidden");
          }
          if (html.querySelector(`#ProductSubmitButton-${this.sectionId}`)) {
            html
              .querySelectorAll(
                ".product-form__input.product-form__input--pill, .product-form__input.product-form__input--swatch, .product_form_input.product-form__input, .product-form__input.product-form__input--dropdown"
              )
              .forEach(function (self, index) {
                let radioCheckedValue = self.querySelector(
                  'input[type="radio"]:checked'
                );

                if (radioCheckedValue) {
                  let value = radioCheckedValue.getAttribute("value");
                  if (value !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }

                if (self.querySelector("select")) {
                  const selectedOption =
                    self.querySelector("select").selectedOptions[0];
                  var selectedValue = selectedOption.getAttribute("value");
                  if (selectedValue !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }
              });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(
                true,
                window.variantStrings.unavailable
              );
            } else {
              this.productForm?.toggleSubmitButton(
                html
                  .querySelector(`#ProductSubmitButton-${this.sectionId}`)
                  ?.hasAttribute("disabled") ?? true,
                window.variantStrings.soldOut
              );
            }
          } else {
            var fullSelected = 1;
            html
              .querySelectorAll(
                ".product-form__input.product-form__input--pill, .product_form_input.product-form__input"
              )
              .forEach(function (self, index) {
                if (self.querySelector('input[type="radio"]:checked')) {
                  if (
                    self
                      .querySelector('input[type="radio"]:checked')
                      .getAttribute("value") !== variant.options[index]
                  ) {
                    fullSelected = 0;
                  }
                }
                if (self.querySelector("select")) {
                  const selectedOption =
                    self.querySelector("select").selectedOptions[0];
                  var selectedValue = selectedOption.getAttribute("value");
                  if (selectedValue !== variant.options[index]) {
                    fullSelected = 0;
                  }
                }
              });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(
                true,
                window.variantStrings.unavailable
              );
            } else {
              this.productForm?.toggleSubmitButton(
                html
                  .querySelector(
                    `#ProductSubmitButton-quickadd-${this.sectionId}`
                  )
                  ?.hasAttribute("disabled") ?? true,
                window.variantStrings.soldOut
              );
            }
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        const selecter =
          this.dataset.layout == "card"
            ? this.dataset.section + "-" + this.dataset.productId
            : this.dataset.section;
        //webcontrive code start
        var $wc_this = this;
        setTimeout(function(){
          $wc_this.querySelectorAll(".thumbnail-list__item").forEach((item) => {
            item.addEventListener("click", function () {
              const targetMediaId = this.getAttribute("data-img-src-id");
              $wc_this.querySelectorAll(".product_main_image").forEach((image) => {
                  if (image.getAttribute("data-img-src-id") === targetMediaId) {
                    image.classList.add("is-active");
                  } else {
                    image.classList.remove("is-active");
                  }
                });
            });
          });
        }, 200);
        this.querySelectorAll(
          `#product-form-${selecter}, #product-form-installment-${selecter}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        this.querySelectorAll(selectors).forEach(({ classList }) =>
          classList.add("hidden")
        );
      }

      updateCardMedia(variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const card = this.closest(".card") || this.querySelector(".card");
        const newMedia = card.querySelector(
          `[data-media-id="${this.dataset.section}-${this.dataset.productId}-${variantFeaturedMediaId}"]`
        );
        if (!newMedia) return;
        const modalContent = card.querySelector(".card__media");
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        parent.prepend(newMedia);
      }

      replaceStringBeforeLastDash(str, replacement) {
        // Find the position of the last dash
        const lastDashIndex = str.lastIndexOf("-");

        // If there's no dash, return the string unchanged
        if (lastDashIndex === -1) {
          return str;
        }

        // Extract everything after the last dash and prepend the replacement
        return replacement + str.substring(lastDashIndex);
      }

      refreshProductFormReferences(productForm) {
        if (!productForm) return;

        productForm.form = productForm.querySelector("form");
        productForm.submitButton = productForm.querySelector('[type="submit"]');
        productForm.submitButtonText =
          productForm.submitButton &&
          productForm.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer") && productForm.submitButton) {
          productForm.submitButton.setAttribute("aria-haspopup", "dialog");
        }
      }

	      updateBuyButtonsFromHtml(html) {
	        if (!html) return false;

	        const productForm = this.productForm;
        const sourceButtons = html.querySelector("[data-tfg-buy-buttons]");
        const destinationButtons = this.querySelector("[data-tfg-buy-buttons]");
        if (!productForm || !sourceButtons || !destinationButtons) return false;

        destinationButtons.outerHTML = sourceButtons.outerHTML;
	        this.refreshProductFormReferences(productForm);
	        return true;
	      }

	      syncSubmitButtonDataFromHtml(html) {
	        if (!html) return;

	        const sourceButton =
	          html.querySelector(`#ProductSubmitButton-${this.sectionId}`) ||
	          html.querySelector(`#ProductSubmitButton-quickadd-${this.sectionId}`) ||
	          html.querySelector(
	            `#product-form-${this.dataset.section}-${this.dataset.productId}-submit`
	          );
	        const destinationButton = this.productForm?.querySelector('[type="submit"]');
	        if (!sourceButton || !destinationButton) return;

	        ["available-text", "sold-out-text"].forEach((name) => {
	          const attribute = `data-${name}`;
	          if (sourceButton.hasAttribute(attribute)) {
	            destinationButton.setAttribute(attribute, sourceButton.getAttribute(attribute));
	          } else {
	            destinationButton.removeAttribute(attribute);
	          }
	        });
	      }

	      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        if (this.dataset.layout == "card") {
          this.updateCardMedia(variantFeaturedMediaId);
        } else {
          const mediaGallerySource = this.querySelector("media-gallery ul");
          const mediaGalleryDestination =
            html.querySelector(`media-gallery ul`);

          const refreshSourceData = () => {
            // if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
            if (this.hasAttribute("data-zoom-on-hover") && typeof enableZoomOnHover == 'function') enableZoomOnHover(2);
            const mediaGallerySourceItems = Array.from(
              mediaGallerySource.querySelectorAll("li[data-media-id]")
            );
            const sourceSet = new Set(
              mediaGallerySourceItems.map((item) => item.dataset.mediaId)
            );
            const sourceMap = new Map(
              mediaGallerySourceItems.map((item, index) => [
                item.dataset.mediaId,
                { item, index },
              ])
            );
            return [mediaGallerySourceItems, sourceSet, sourceMap];
          };

          if (mediaGallerySource && mediaGalleryDestination) {
            let [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();
            const mediaGalleryDestinationItems = Array.from(
              mediaGalleryDestination.querySelectorAll("li[data-media-id]")
            );
            const destinationSet = new Set(
              mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
            );
            let shouldRefresh = false;

            if (!this.dataset.isQuickView) {
              // add items from new data not present in DOM
              for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
                if (
                  !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
                ) {
                  mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                  shouldRefresh = true;
                }
              }
  
              // remove items from DOM not present in new data
              for (let i = 0; i < mediaGallerySourceItems.length; i++) {
                if (
                  !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
                ) {
                  mediaGallerySourceItems[i].remove();
                  shouldRefresh = true;
                }
              }
            }

            // refresh
            if (shouldRefresh)
              [mediaGallerySourceItems, sourceSet, sourceMap] =
                refreshSourceData();
            // this.imgsrcs = [];
            // if media galleries don't match, sort to match new data order
            mediaGalleryDestinationItems.forEach(
              (destinationItem, destinationIndex) => {
                const sourceData = sourceMap.get(
                  destinationItem.dataset.mediaId
                );
                if (sourceData && sourceData.index !== destinationIndex) {
                  mediaGallerySource.insertBefore(
                    sourceData.item,
                    mediaGallerySource.querySelector(
                      `li:nth-of-type(${destinationIndex + 1})`
                    )
                  );

                  // refresh source now that it has been modified
                  [mediaGallerySourceItems, sourceSet, sourceMap] =
                    refreshSourceData();
                }
              }
            );
          }

          // set featured media as active in the media gallery
          const selector = this.dataset.isQuickView ? "quickadd-" : "";
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${selector}${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );

          // update media modal
          const modalContent = this.productModal?.querySelector(
            `.product-media-modal__content`
          );
          const newModalContent = html.querySelector(
            `product-modal .product-media-modal__content`
          );
          
          if (modalContent && newModalContent)
            modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.querySelector(
          `#Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return (
          this.querySelector("variant-selects") ||
          this.querySelector("color-swatch")
        );
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

document.addEventListener("change", function (event) {
  if (event.target.classList.contains("wc_selector_operation")) {
    let closestFeature = event.target.closest(".featured_collection_home");
    if (!closestFeature) return;

    let dataId = closestFeature.getAttribute("data-id");

    setTimeout(() => {
      let radioButtons = closestFeature.querySelectorAll(
        ".wc_selector_operation"
      );
      radioButtons.forEach((radio) => {
        let originalName =
          radio.getAttribute("data-original-name") ||
          radio.getAttribute("name");
        radio.setAttribute("data-original-name", originalName);
        radio.setAttribute("name", `${originalName}_${dataId}`);
      });
    }, 1000);
  }
});
